<script setup lang="ts">
import { onUpdated } from "vue";
import { defineProps } from "vue";


const props = defineProps({
  show: Boolean,
  showForm: Boolean,
  lotId: String,
  isWideScreen: Boolean
})
onUpdated(()=>{
  const testScript = document.createElement("script");
  testScript.innerHTML = `hbspt.forms.create({
                          region: "na1",
                          portalId: "1763197",
                          formId: "8cc36b0f-f85d-47bb-849a-5e59d82d449d"
                });`
  var modalTest = document.querySelector('#formEmbed');
  modalTest?.appendChild(testScript);
  var interval = setTimeout(()=>{
    var inputData = document.querySelector('iframe');
    if(inputData){
      var test = inputData!.contentWindow!.document.querySelector('input[name=lot_number_interested_in__np_]');
      test!.value = props.lotId;
    }
  }, 1000);

})

</script>

<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :class="{ 'wide-screen-modal': isWideScreen}">
          <button
                class="modal-close-button"
                @click="$emit('close')"
              ></button>
          <div class="modal-header">
            <slot name="header">default header</slot>
          </div>
          <div class="modal-body" v-if="!showForm">
            <slot name="body">default body</slot>
          </div>
          <div class="modal-form" id="formEmbed" v-else>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  font-family:'Roboto', sans-serif;
  font-size: larger;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-width: 22rem;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.6rem rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  color: #131E29;
}

.wide-screen-modal{
  margin-right: calc(50vw - 25.625rem);
}
.modal-body{
      flex-direction: column !important;
      max-height: 80vh;
      overflow: auto;
      padding-bottom: 0.5rem;
      text-align: left;
  }

#formEmbed{
  margin-right: auto;
  margin-left: 3em;
  margin-top: 1em;
}

@media only screen and (max-width: 480px){

  .modal-body{
      flex-direction: column !important;
      align-items: flex-start !important;
  }
}
@media only screen and (max-width: 620px){
.modal-container {
     width: 90%;
  }
  .modal-body{
      flex-direction: column !important;
      align-items: center !important;
  }
}

.modal-header {
  font-size: medium;
  text-align: left;
  padding-top: 1rem;
  padding-left: 1.5rem;
  color: #747474;
  display: flex;
  flex-direction: column;
}

.modal-body {
  margin: 0 0px;
  text-align: center;
  color: #131E29;
}

.modal-close-button {
  float: right;
  position: relative;
  border: none;
  top: 1rem;
  right: 1rem;
  background-color: #fff;
  background-image: url('./../assets/x-icon.svg');
  background-size: contain;
  width: 1.5rem;
  height: 1.5rem;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>